import React, { useState, Component, useEffect } from 'react';
import { connect } from 'react-redux'
import * as actions from '@/models/orders/actions'
import * as services from '@/models/orders/services';
import cn from 'classnames';
import { Modal, Form, Button, Select, Input, Popconfirm, message, InputNumber, DatePicker, Tabs } from 'antd';
import styles from './style.module.less';
import dayjs from 'dayjs'
import * as apis from '@/apis'

function GuaqiOrder(props) {
  const { children, order, form, change } = props
  const { getFieldDecorator, validateFields, getFieldValue, resetFields } = form;

  const [showDialog, toggleDialog] = useState(false);
  const [reasonList, setReasonList] = useState([]);
  const [activeKey, setActiveKey] = useState('0');

  const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };
  const initData = () => {
    apis.getAllReasons({ type: 'guaqi' }).then(res => {
      setReasonList(res.reason || []);
    })
    // services.getGuaqiSelect().then(res => {
    //   // setReasonList(res.data || []);
    // })
  }
  const handleSubmit = () => {
    validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }

      let reason = values.guaqi_reason || values.cancel_memo
      // if (values.cancel_memo) {
      //   reason += ' - ' + values.cancel_memo
      // }

      services.orderGuaqi({
        orderId: order.get('_id'),
        guaqi_reason: reason,
        service_time: values.service_time
      }).then(result => {
        message.success('提交成功')
        toggleDialog(false)
        typeof change === 'function' && change()
      }).catch(err => {
        message.error(err.message || '发生错误')
      }).finally(() => {
      })
    });
  }
  useEffect(() => {
    initData()
  }, [])

  return (
    <React.Fragment>
      {
        React.isValidElement(children) && React.cloneElement(children, {
          onClick: toggleDialog,
        })
      }
      <Modal
        title="挂起工单"
        destroyOnClose

        width={500}
        visible={!!showDialog}
        onOk={() => { handleSubmit() }}
        onCancel={() => toggleDialog(false)}

        mask={false}
        wrapClassName="order-detail-modal-wrap"
        maskStyle={{ position: 'absolute' }}
        getContainer={() => document.getElementById('order-detail-wrap') || window}
      >
        <Form {...formItemLayout} className={styles.form}>
          <Tabs
            defaultActiveKey={activeKey}
            size="small"
            onChange={(val) => {
              setActiveKey(val)
              resetFields()
            }}>
            {
              reasonList.map((item, index) => {
                return <Tabs.TabPane tab={item.name} key={String(index)} ></Tabs.TabPane>
              })
            }
          </Tabs>
          {reasonList[activeKey]?.name != '其他原因' ? <Form.Item label="挂起原因" width={120}>
            {getFieldDecorator('guaqi_reason', {
              rules: [
                {
                  required: true,
                  message: '请选择挂起原因',
                },
              ],
            })(
              <Select placeholder="请选择挂起原因">
                {
                  reasonList[activeKey]?.list.map(reason => {
                    if (reason.groupName && reason.list) {
                      return (
                        <Select.OptGroup key={reason.groupName} label={reason.groupName}>
                          {
                            reason.list.map(reason => (
                              <Select.Option key={reason} value={reason}>{reason}</Select.Option>
                            ))
                          }
                        </Select.OptGroup>
                      )
                    }

                    return <Select.Option key={reason} value={reason}>{reason}</Select.Option>
                  })
                }
              </Select>
            )}
          </Form.Item> :
            <Form.Item label="其他原因">
              {getFieldDecorator('cancel_memo', {
                rules: [
                  {
                    required: true,
                    message: '请输入其他原因',
                  },
                ],
              })(
                <Input.TextArea rows={4} placeholder="请输入其他原因"></Input.TextArea>
              )}
            </Form.Item>

          }
          {/* {getFieldValue('guaqi_reason') == '其他' &&
            <Form.Item label="其他原因">
              {getFieldDecorator('cancel_memo', {
                rules: [
                  {
                    required: true,
                    message: '请输入其他原因',
                  },
                ],
              })(
                <Input.TextArea placeholder="请输入其他原因"></Input.TextArea>
              )}
            </Form.Item>
          } */}
          <Form.Item label="预约时间">
            {getFieldDecorator('service_time', {
              initialValue: order.get('service_time') ? dayjs(order.get('service_time')) : null,
              rules: [
                {
                  required: true,
                  message: '请选择上门时间',
                },
              ],
            })(
              <DatePicker
                showTime={{ format: 'HH:mm', minuteStep: 5 }}
                format="YYYY-MM-DD HH:mm"
                placeholder="选择上门时间"
                style={{ width: '100%' }}
              />
            )}
          </Form.Item>
        </Form>
      </Modal>
    </React.Fragment>
  );
}


export default connect()(Form.create()(GuaqiOrder))